<template>
    <v-layout v-if="loading" style="position: relative; min-height: 200px;" align-center justify-center>
        <loading></loading>  
    </v-layout>
    <v-flex v-else>
        <v-layout wrap>
            <v-flex xs12>
                <v-alert :value="error != null" outline type="error">
                    <span>{{ error }}</span>
                </v-alert>
            </v-flex>
        </v-layout>

        <v-layout wrap>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2>
                <v-btn v-if="editMode" right class="primary mx-4" @click="showAddEditDialog(null)">Add</v-btn>
            </v-flex>
        </v-layout>
        
        <v-data-table :headers="headers" :items="absences" no-data-text="Attendance Member has no absences" hide-actions>
            <template v-slot:items="props">
                <td>{{ props.item.AbsenceType.Name }}</td>
                <td>{{ props.item.StartTime | formatDateTime}}</td>
                <td>{{ props.item.EndTime | formatDateTime }}</td>
                <td style="max-width: 10%">
                    <v-btn v-if="editMode" right class="primary" @click="showAddEditDialog(props.item)">Edit</v-btn>
                    <v-btn v-if="editMode" right class="error" @click="handleDelete(props.item)">Delete</v-btn>
                </td>
            </template>
        </v-data-table>

        <v-dialog :value="addEditDialog" max-width="500px" persistent @keydown.esc="handleCloseEdit()">
            <absence-edit v-if="addEditDialog" :editData="editAbsence" :types="absenceTypes" :date="attendanceDate" :attendanceID="attendanceID" @close="handleCloseEdit()">
            </absence-edit>
        </v-dialog>
        
        <delete-dialog :DisplayDialog="showConfirmDelete" :DialogTitle="'Delete Item'" :DialogContents="'Are you sure you wish to delete this entry?'" @No="handleDeleteCancel" @Yes="handleDeleteConfirm"></delete-dialog>

    </v-flex>
</template>

<script>
import absenceApi from '@/api/absenceApi';
import Loading from '@/components/generic/Loading.vue';
import AbsenceEdit from '@/components/plants/team/addEditAbsence.vue';
import DeleteDialog from '@/components/generic/YesNoPopup.vue';

export default {
    components: {
        Loading,
        AbsenceEdit,
        DeleteDialog,
    },
    props: {
        attendanceMemberID: {
            required: true,
            type: Number
        },
        attendanceID: {
            required: true,
            type: Number
        },
        editMode: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            loading: false,
            error: null,
            submitError: null,
            submitLoading: false,
            absences: [],
            addEditDialog: false,
            editAbsence: null,
            absenceTypes: [],
            attendanceDate: null,
            showConfirmDelete: false
        }
    },
    computed: {
        headers() {
            return  [
                { text: 'Type', value: 'AbsenceType', sortable: false  },
                { text: 'Start', value: 'StartTime'},
                { text: 'End', value: 'EndTime' },
                { text: 'Edit', value: 'Edit', sortable: false }
            ]
        },
        newAbsence() {
            return {
                absenceID: -1,
                AbsenceType: {
                    AbsenceTypeID: -1,
                    Name: null
                },
                AttendanceMemberID: this.attendanceMemberID,
                StartTime: '1970-01-01T00:00:00',
                EndTime: '1970-01-01T00:00:00'
            }
        }
    },
    methods: {
        showAddEditDialog(targetAbsence) {
            console.log(targetAbsence)
            if(targetAbsence == null){
                this.editAbsence = JSON.parse(JSON.stringify(this.newAbsence))
            }
            else {
                this.editAbsence = JSON.parse(JSON.stringify(targetAbsence))
            }
            this.addEditDialog = true;
        },
        handleDelete(item) {
            this.targetAbsence = item;
            this.showConfirmDelete = true;
        },
        handleDeleteCancel() {
            this.targetAbsence = null;
            this.showConfirmDelete = false;
        },
        async handleDeleteConfirm() {
            this.loading = true;
            //delete
            try{
                let response = await absenceApi.deleteAttendanceMemberAbsence(this.targetAbsence);
                console.log(response);
                this.load();
            } catch (error) {
                console.log('error', error)
                this.error = error;
            }
            this.loading = false;
            this.targetAbsence = null;
            this.showConfirmDelete = false;
        },
        handleCloseEdit() {
            this.targetAbsence = null;
            this.addEditDialog = false;
            this.load()
        },
        async load() {
            this.loading = true;
            console.log('load')
            try {
                let absenceDetail = await absenceApi.getAttendanceMemberAbsences(this.attendanceMemberID);
                this.absences = absenceDetail.Absences;
                this.absenceTypes = absenceDetail.AbsenceTypes;
                this.attendanceDate = absenceDetail.AttendanceDate;
            } catch (error) {
                console.log('error', error)
                this.error = error;
            }

            this.loading = false;
        },
    },
    async created() {
        this.load();
    }
}
</script>